import _ from 'lodash';
import getTexto from './messages';
import { getLanguage } from './language';

export function isHome(location){
 
  return location.pathname === process.env.PUBLIC_URL + '/' || location.pathname === process.env.PUBLIC_URL || location.pathname === process.env.PUBLIC_URL + '/index.html'
}

export function backToTop() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
export function getParamsFromUrl(variable) {
  let search = window.location.search.substr(1);
  var searchParams = new URLSearchParams(search);
  return searchParams.get(variable);
}
export function getAllParamsFromUrl() {
  let search = window.location.search.substr(1);
  var searchParams = new URLSearchParams(search);
  return searchParams;
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
export function isKsk(site) {
  return site?.initialConfig?.WebSection === kskTag()//"KSK"
}
export function isRentals(site) {
  return site?.initialConfig?.WebSection === rentalsTag()//"RENTAL"
}
export function isGifts(site) {
  return site?.initialConfig?.WebSection === giftsTag()//"SPGIFT"
}
export function kskTag() {
  return "KSK"
}
export function rentalsTag() {
  return "Rentals"
}
export function giftsTag() {
  return "SpecialGifts"
}
export function getWebSectionForEndpoint(webSection = "KSK"){
  let tag = kskTag();
  switch(webSection){
    case "KSK":  tag = kskTag(); break;
    case "RENTAL":  tag = rentalsTag(); break;
    case "SPGIFT":  tag = giftsTag(); break;
    default:  tag = kskTag();break
  }

  return tag;
}
// function getCookie(cname) {
//   var name = cname + '=';
//   var decodedCookie = decodeURIComponent(document.cookie);
//   var ca = decodedCookie.split(';');
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) === ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) === 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return '';
// }

export function openModalForLogin(config, reduxLogin) {
  var left = Screen.width / 2 - 400 / 2;
  var top = Screen.height / 2 - 600 / 2;
  var strWindowFeatures =
    'menubar=no,location=no,resizable=no,scrollbars=yes,status=no,width=400,innerHeight=600,centerscreen=yes,chrome=yes, top=' +
    top +
    ', left=' +
    left +
    '';
  window['output'] = function (userToken ) {
    console.log(userToken);
    reduxLogin(userToken);
  };
  
  let idioma = getLanguage() =="en-US"? "en": "es";
  window.open(
    config.urlToGetTokenToLogin +
      '?Code=' +
      config.codeToGetTokenToLogin +
      '&Lang='+idioma+
      '&ReturnUrl=' +
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.hostname === 'localhost' ? ':3000' : '') +
      '/redirect.html',
    'CNN_WindowName',
    strWindowFeatures
  );
}
export function RetrieveRandomObjByCat(objects, cat, numberToRetrieve) {
  let arrayItems = [];
  let itents = 0;
  let itemsFilteredByCat = _.filter(objects, function (o) {
    return o.ItemExt.Group.SGroupCode === cat;
  });
  while (arrayItems.length < numberToRetrieve && itents < 1000) {
    let number = _.random(0, Object.keys(itemsFilteredByCat).length);
    let newArray = itemsFilteredByCat.slice(number, number + 1);
    if (newArray.length > 0) {
      if (
        _.findIndex(arrayItems, function (o) {
          return o.IItemID === newArray[0].IItemID;
        }) === -1
      ) {
        arrayItems.push(...newArray);
      }
    }
    itents++;
  }
  return arrayItems;
}

export function openModalForRetrieveUser(config, reduxLogin) {
  var left = Screen.width / 2 - 400 / 2;
  var top = Screen.height / 2 - 600 / 2;
  var strWindowFeatures =
    'menubar=no,location=no,resizable=no,scrollbars=yes,status=no,width=400,innerHeight=600,centerscreen=yes,chrome=yes, top=' +
    top +
    ', left=' +
    left +
    '';
  window['output'] = function (userToken) {
    reduxLogin(userToken);
  };
  window.open(
    config.urlToRetrieveTokenToLogin +
      '?Code=' +
      config.codeToGetTokenToLogin +
      '&ReturnUrl=' +
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.hostname === 'localhost' ? ':3000' : '') +
      '/redirect.html',
    'CNN_WindowName',
    strWindowFeatures
  );
}

export function removeCharactersFromText(str) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    let char = str[i];
    if (
      (char === '*' && str[i + 1] === '*') ||
      (char === '_' && str[i + 1] === '_')
    ) {
      i++;
      continue;
    }
    result = result + char;
  }
  return result;
}
export function getRichText(str) {
  let result = '';
  let key = '';
  for (let i = 0; i < str.length; i++) {
    let char = str[i];
    if (char === '*' && str[i + 1] === '*' && key === '') {
      result = result + '<strong>';
      key = '*';
      i++;
      continue;
    } else if (char === '*' && str[i + 1] === '*' && key === '*') {
      result = result + '</strong>';
      key = '';
      i++;
      continue;
    }

    if (char === '_' && str[i + 1] === '_' && key === '') {
      result = result + '<span style="text-decoration: underline">';
      key = '_';
      i++;
      continue;
    } else if (char === '_' && str[i + 1] === '_' && key === '_') {
      result = result + '</span>';
      key = '';
      i++;
      continue;
    }
    result = result + char;
  }

  return result;
}
export function filterItemsByNew(items) {
  let newResultItems = []; // adding all the items that have the YnNewItem node set to 1
  items.forEach((item) => {
    if (item.YnNewItem && item.YnNewItem === '1') {
      newResultItems.unshift(item);
    } else {
      newResultItems.push(item);
    }
  });
  return newResultItems;
}

export function addOfferCategory(list) {
  return [
    {
      ICategoryID: 'ALL',
      SCategoryCode: 'ALL',
      SCategoryDesc: getTexto('All Categories'),
      LsGroup: [
        {
          IGroupID: 999999,
          SGroupCode: 'ALL',
          SGroupDesc: getTexto('All Categories'),
        },
      ],
    },
    ...list,
    {
      ICategoryID: 'OFFER',
      SCategoryCode: 'OFFER',
      SCategoryDesc: 'OFFERS',
      LsGroup: [
        {
          IGroupID: 0,
          SGroupCode: 'OFFER',
          SGroupDesc: 'OFFERS',
        },
      ],
    },
  ];
}

export function getOfferPriceDetails(item) {
  let result = {
    priceWDiscount: item.OfferDetail.reduce((a, b) => a.Price + b.Price),
    price: item.OfferDetail.reduce(
      (a, b) => a.Price - a.Discount + b.Price - b.Discount
    ),
    totalDiscount: item.OfferDetail.reduce((a, b) => a.Discount + b.Discount),
  };
  return result;
}

export function getDetailsCart(cart) {
  let result = {
    subTotal: 0.0,
    discount10: 0.0, 
    discountOffer: 0.0,
    total: 0.0,
  };
  cart.map((item) => {
    if (item.item.isOffer) {
      result.subTotal +=
        parseFloat(item.item.priceDetails.priceWDiscount).toFixed(2) *
        parseFloat(item.totalItems);
      result.discountOffer +=
        parseFloat(item.item.priceDetails.totalDiscount).toFixed(2) *
        parseFloat(item.totalItems);
      result.total +=
        parseFloat(item.item.priceDetails.price).toFixed(2) *
        parseFloat(item.totalItems);
    } else {
      let priceItem =
        parseFloat(item.item.DPrice).toFixed(2) * parseFloat(item.totalItems);
      result.subTotal += priceItem;
      result.discount10 += parseFloat(priceItem).toFixed(2) * getDiscountByTag();
      result.total += priceItem * (1 - getDiscountByTag());
    }
    return true;
  });
  result['totalPrice'] = result.subTotal;

  return result;
}

export function thereIsDiscountByTag(webSection = localStorage.getItem('site') ? localStorage.getItem('site') : "KSK" ){
  let discout = true;
  switch(webSection){
    case "KSK":  discout = true; break;
    case "RENTAL":  discout = false; break;
    case "SPGIFT":  discout = false; break;
    default:  discout = false;break
  }
  return discout;
}
export function getDiscountByTag(webSection = localStorage.getItem('site') ? localStorage.getItem('site') : "KSK" ){
  let discout = 0.1;
  switch(webSection){
    case "KSK":  discout = 0.1; break;
    case "RENTAL":  discout = 0.0; break;
    case "SPGIFT":  discout = 0.0; break;
    default:  discout = 0.0;break
  }
  return discout;
}
